
export const distance2D = (ax: number, ay: number, bx: number, by: number) => {
  const xDiff = ax - bx;
  const yDiff = ay - by;
  return Math.sqrt((xDiff * xDiff) + (yDiff * yDiff));
}
